import { call, put, select, race, delay } from "redux-saga/effects";
import getDevicesPromise from '@/services';
import { actions } from '@/reducers/devices'
const contextStore = (state) => state.main.context;

export const normalizeGetDevicesResponse = (data) => {
  const { data: responseData } = { ...data };
  const { results: devices } = { ...responseData };
  if (Array.isArray(devices) && devices.length > 0) {
    const newData = devices
      .map((device) => {
        const label = `${device.market_name} - Hasta ${parseInt(device?.price)} €`;
        const value = device.id;
        return {
          imageUrl: device?.image_url,
          label,
          value,
          price: parseFloat(device?.price),
          productName: device.market_name,
        };
      })
      .slice(0, 20);
    return newData;
  }
  return null;
};

export function* getDevices({ payload }) {
  const contextApi = yield select(contextStore);
  try {
    const { data } = { ...payload };
    const { id } = { ...data };
    yield delay(300);
    const response = yield call(getDevicesPromise, {
      context: contextApi,
      id,
    });
    const devices = normalizeGetDevicesResponse(response);
    yield put(
      actions.getDevicesSuccess({
        devices,
      })
    );
  } catch (error) {
    //   reportJSError(
    //     error,
    //     'getDeviceFinder',
    //     'sagas/tradeIn/form-sagas',
    //     contextApi
    //   );
    //   const errorInfo = normalizeErrorInfo(
    //     error,
    //     WEB_SERVICES.DEVICE_FINDER,
    //     contextApi
    //   );
    yield put(errorActions.setError(errorInfo));
  }
}
